module.exports = __webpack_public_path__ + "static/media/drag-n-drop.4104b846.svg";